module.exports = __webpack_public_path__ + "static/media/pessocial2.50b74a34.png";